import React,{useState,useEffect} from "react";
import { Row, Col, Typography, Table } from "antd";
import { Container } from "./Components";
import {capitalize,nFormatter} from "utils/randomString"

const { Title, Text } = Typography;


export default function OtherTradingPartners({ data }) {
    const [dataSource, setDataSource] = useState([]);
    const [columns, setColumns] = useState([])
  

  useEffect(() => {

    if (data && data.length > 0) {
        setColumns([
            {
                title: "City",
                dataIndex: "city",
                key: "city",

            },
            {
                title: "Trading partners",
                dataIndex: "trading_partners",
                key: "trading_partners",

            },
            {
                title: "Value",
                dataIndex: "value",
                key: "value",
            },
            // {
            //     title: "Product Details",
            //     dataIndex: "product_details",
            //     key: "product_details",
            // }
        ])
     setDataSource(data.map((item, index) => {
         return {
                city: capitalize(item?.city),
                trading_partners: item?.partners,
                value: `$ ${nFormatter(item?.monetary_value)}`,
                // product_details: item?.product_details
         }
     }))
        
    }

  },[data])
  return (
    <Container>
      <Col span={24}>
        <Row>
          <Title level={4}>{`Other Trading Partners`}</Title>
        </Row>
        <Row>
          <Text type="secondary">Since 2021</Text>
        </Row>

        <Row style={{marginTop:'2em'}}>
          <Col span={24}>
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              size="middle"
            />
           
          </Col>
        </Row>
      </Col>
    </Container>
  );
}
